import type { Components, Theme } from "@mui/material/styles";
import { MuiAlert } from "./MuiAlert";
import { MuiAutocomplete } from "./MuiAutocomplete";
import { MuiButton } from "./MuiButton";
import { MuiChip } from "./MuiChip";
import { MuiDataGrid } from "./MuiDataGrid";
import { MuiDialogActions } from "./MuiDialogActions";
import { MuiFormHelperText } from "./MuiFormHelperText";
import { MuiIcon } from "./MuiIcon";
import { MuiLinearProgress } from "./MuiLinearProgress";
import { MuiListItemButton } from "./MuiListItemButton";
import { MuiSelect } from "./MuiSelect";
import { MuiTabs } from "./MuiTabs";
import { MuiToggleButtonGroup } from "./MuiToggleButtonGroup";
import { MuiTooltip } from "./MuiTooltip";
import { MuiTreeItem } from "./MuiTreeItem";

export const componentOverrides: Components<Theme> & {
  MuiDataGrid?: unknown;
  MuiTreeItem?: unknown;
} = {
  // MuiCssBaseline, // not needed anymore because channels colors shouldn't be used when "nativeColor: true" is set - https://mui.com/material-ui/migration/upgrade-to-native-color/#remove-usage-of-channel-tokens
  MuiToggleButtonGroup,
  MuiAlert,
  MuiAutocomplete,
  MuiIcon,
  MuiTooltip,
  MuiDataGrid,
  MuiChip,
  MuiLinearProgress,
  MuiListItemButton,
  MuiSelect,
  MuiTreeItem,
  MuiTabs,
  MuiButton,
  MuiDialogActions,
  MuiFormHelperText,
};
